export const url = {
    // baseUrl: "https://ncl-backend.stagemyapp.com",
    // sitemap_path: "/home/app/ncl/public/sitemap.xml",
    // sitemap_build_path: "/home/app/ncl/public/sitemap.xml",
    baseUrl: "https://www.nclcil.in/",
    sitemap_path: "",
    sitemap_build_path: "/usr/share/nginx/html/sitemap.xml",
    home: "/api/v2/homepage/",
    sitemap: "/api/v2/sitemap/",
    upcoming_events: "/api/v2/upcoming_events/",
    past_events: "/api/v2/past_events/",
    visitors_count: "/api/v2/visitors_count/",
    visitors_count_update: "/api/v2/visitors_count_update/",
    last_updated_date: "/api/v2/last_updated_date/",
    pages: "/api/v2/pages/",
    data_listing: "/api/v2/data_listing/",
    data_listing_detail: "/api/v2/data_listing_detail/",
    menus: "/api/v2/menus/",
    news_and_updates: "/api/v2/news_and_updates/",
    search_page: "/api/v2/search-page/",
    media_gallery: "/api/v2/photo-gallery/",
    media_gallery_detail: "/api/v2/photo-gallery-details/",
    video_gallery: "/api/v2/video-gallery/",
    corporate_song: "/api/v2/corporate-songs/",
    penal_actions: "/api/v2/penal_actions/",
    recruitment: "/api/v2/recruitments/",
    tenders: '/api/v2/tenders-by-period/',
    tenders_static_data: '/api/v2/tenders-static-data/',
    feedback: '/api/v2/submit_feedback/',
    site_banners: '/api/v2/site_banners/',
    register: '/api/auth/register/',
    verify_otp: '/api/auth/verify-otp/',
    resend_otp: '/api/auth/resend-otp/',
    login: '/api/auth/login/',
    forgot_password: '/api/auth/forgot-password/',
    new_password: '/api/auth/new-password/',
    subsidiaries: '/api/auth/subsidiaries/',
    me: '/api/auth/me/',
    profile: '/api/auth/profile/',
    logout: '/api/auth/logout/',
};